import { useQuery } from '@tanstack/react-query'

import { Card, CardContent, Spinner } from '../../components/ui'
import { AXIOS_INSTANCE } from '../../services/api-client'

export default function SourceReportPage() {
  const { data: html, isLoading, error } = useQuery<string>({
    queryKey: ['lag-accruals', 'source-report'],
    queryFn: async () => {
      const response = await AXIOS_INSTANCE.get('/api/lag-accruals/source-report', {
        responseType: 'text',
      })
      return response.data
    },
    staleTime: 60_000,
  })

  if (isLoading) {
    return (
      <div className="flex min-h-[360px] items-center justify-center">
        <Spinner size="lg" />
      </div>
    )
  }

  if (error || !html) {
    return (
      <Card>
        <CardContent className="p-6 text-sm text-red-600 dark:text-red-400">
          Unable to load the original source report.
        </CardContent>
      </Card>
    )
  }

  return (
    <div className="overflow-hidden rounded-lg border border-gray-200 bg-white dark:border-dark-border dark:bg-dark-surface">
      <iframe
        title="Original EC-02d report"
        srcDoc={html}
        className="h-[calc(100vh-280px)] min-h-[640px] w-full bg-white"
        sandbox="allow-scripts"
      />
    </div>
  )
}
